export const DEFAULT_HEADERS = { "Content-Type": "application/json", Accept: "application/json" };
export const MULTIPART_HEADERS = { "Content-Type": "multipart/form-data" };
export const LOGOUT_PAGE_ROUTE = "/login";